import {HttpClient} from '@angular/common/http';
import {Component, Inject, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {EnumerationService} from '../enumeration/enumeration.service';
import {AppConfig} from '../config/app.config';
import {AuthenticationService} from '@ngx-ivengi/authentication';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import {SharedService} from '../shared/shared.service';
import {Exportation} from './exportation.model';
import {ExportationService} from './exportation.service';
import 'rxjs/add/operator/delay';
import { UIRouter } from '@uirouter/angular';
import { priceType } from '../price/price.enum';
import * as _ from 'lodash';

enum output {
  DOWNLOAD = 'download',
  INLINE = 'inline'
}

enum exportStep {
  SELECT = 'select',
  RENDER = 'render',
  DONE   = 'done',
  ERROR  = 'error'
}

@Component({
  selector: 'app-exportation-modal',
  templateUrl: './exportation-modal.component.html'
})
export class ExportationModalComponent implements OnInit {
  public  exports: {value: string, icon: string, select?: string[]}[]  = [];
  public  output: output                            = output.DOWNLOAD;
  public  exportStep: exportStep                    = exportStep.SELECT;
  public  outputEnum                                = output;
  public  exportStepEnum                            = exportStep;
  private renderedExportation;
  private priceTypes = Object.keys(priceType).map((key) => priceType[key]);
  public selectedExportOptions: Record<string, string[]> = {
    PRICE: _.clone(this.priceTypes),
    PRICE_AGGREGATION: _.clone(this.priceTypes),
  };

  @Input() data: {
    assignmentId: string[],
    channelId: string[],
    bsModalRef: BsModalRef
  };
  @Input() channelId: string|string[];
  protected hoveredExport = null;

  constructor(
    @Inject(AppConfig) private appConfig,
    private enumService: EnumerationService,
    private authService: AuthenticationService,
    private http: HttpClient,
    private exportationService: ExportationService,
    private sharedService: SharedService,
    protected router: UIRouter
  ) {
  }

  public doRender(type) {
    this.sharedService.forceHideOfLoader();
    const requestParams: {[key: string]: string|string[]} = {};

    if(this.data.assignmentId) {
      requestParams.assignmentId = this.data.assignmentId;
    }

    if(this.data.channelId) {
      requestParams.channelId = this.data.channelId;
    }

    if (this.selectedExportOptions[type] && this.selectedExportOptions[type].length > 0) {
      requestParams['options'] = this.selectedExportOptions[type];
    }

    this.exportStep = exportStep.RENDER;
    this.http.post(`${this.appConfig.apiUrl}/exportation/render/${type.toLowerCase()}`, requestParams).subscribe((response: any) => {

      const exportation = new Exportation();
      exportation.fromResponse(response);

      this.checkExportationStatus(exportation.id);
    },
    (err) => {
      this.exportStep = exportStep.ERROR;
      this.sharedService.removeForceHideOfLoader();
    });
  }

  public checkExportationStatus(exportId: string) {
    this.exportationService.get(exportId).delay(1000).subscribe((exportation: Exportation) => {
      switch(exportation.status) {
        case 'QUEUED': {
          this.checkExportationStatus(exportId);
          break;
        }

        case 'PROCESSING': {
          this.checkExportationStatus(exportId);
          break;
        }

        case 'FINISHED': {
          this.exportStep = exportStep.DONE;
          this.renderedExportation = exportation;
          this.sharedService.removeForceHideOfLoader();
          break;
        }

        case 'FAILED': {
          this.exportStep = exportStep.ERROR;
          this.sharedService.removeForceHideOfLoader();
          break;
        }
      }
    }, (err) => {
      this.exportStep = exportStep.ERROR;
      this.sharedService.removeForceHideOfLoader();
    });
  }

  public doOutput(outputType) {
    const outputParams = new URLSearchParams();
    outputParams.set('output',        outputType.toString());
    outputParams.set('access_token', this.authService.getAccessToken());

    switch(this.output) {
      case output.DOWNLOAD : {
        window.location.href = `${this.appConfig.apiUrl}/exportation/output/${this.renderedExportation.id}?${outputParams.toString()}`;
      } break;

      case output.INLINE: {
        window.open(`${this.appConfig.apiUrl}/exportation/output/${this.renderedExportation.id}?${outputParams.toString()}`, 'blank');
      } break;
    }

    this.exportStep = exportStep.SELECT;
    this.data.bsModalRef.hide();
    // todo: close the modal
  }

  public ngOnInit() {

    const exportIcons = {
      CHANNEL_OVERVIEW: 'fa-circle-o',
      PRICE: 'fa-money',
      PRICE_AGGREGATION: 'fa-eur',
      REPORTS: 'fa-tasks',
      PICTURES: 'fa-picture-o',
      DRAWINGS: 'fa-file-pdf-o'
    };

    const assignmentId = this.router.stateService.params.assignmentId || '';

    this.enumService.get('exportation-type', assignmentId).map((exportations) => {
      return exportations.map((item) => {
        return {
          value: item,
          icon: (exportIcons[item]) ? exportIcons[item] : 'fa-file-o'
        };
      });
    }).subscribe((exportations) => {
      this.exports = exportations.map((exportation) => {
        if(exportation.value === 'PRICE' || exportation.value === 'PRICE_AGGREGATION') {
          exportation.select = this.priceTypes;
        }
        return exportation;
      });
    });
  }

  onExportOptionsChange(event: any, value: string, exportType: string) {
    if (event.target.checked) {
      if (!this.selectedExportOptions[exportType].includes(value)) {
        this.selectedExportOptions[exportType].push(value);
      }
    } else {
      const index = this.selectedExportOptions[exportType].indexOf(value);
      if (index > -1) {
        this.selectedExportOptions[exportType].splice(index, 1);
      }
    }
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/exportation/exportation-modal.component.ts